import { Box } from "@mui/material";
import { darken, useTheme } from "@mui/material/styles";
import type { AlertColor } from "@mui/material/Alert";

interface ToastTimerBarProps {
	readonly severity: AlertColor;
	readonly timeout: number;
}

export const ToastTimerBar = ({ severity, timeout }: ToastTimerBarProps) => {
	const theme = useTheme();

	return (
		<Box
			data-testid="toast-provider__toast__timer-border"
			sx={{
				position: "absolute",
				left: 0,
				bottom: 0,
				height: 2,
				width: "100%",
				transformOrigin: "left",
				backgroundColor: darken(theme.palette[severity].main, 0.25),
				animation: `toast-timer-border ${timeout}ms linear forwards`,
				"@keyframes toast-timer-border": {
					from: {
						transform: "scaleX(1)",
					},
					to: {
						transform: "scaleX(0)",
					},
				},
			}}
		/>
	);
};
